var SolutionFamilyComponentController = (function () {
    function SolutionFamilyComponentController() {
    }
    SolutionFamilyComponentController.prototype.$onInit = function () {
        this.expanded = false;
    };
    SolutionFamilyComponentController.prototype.expand = function () {
        this.expanded = true;
        this.groups = this.family.groups;
    };
    SolutionFamilyComponentController.prototype.onGroupsInColumnChange = function (columnsInRow) {
        if (this.expanded) {
            return;
        }
        this.groupsInColumn = columnsInRow;
        this.groups = this.family.groups.slice(0, this.groupsInColumn);
    };
    SolutionFamilyComponentController.$inject = [];
    return SolutionFamilyComponentController;
}());
export var SolutionFamilyComponent = {
    bindings: {
        family: '<',
        isListView: '<',
        thirdPartyDevices: '<',
    },
    controller: SolutionFamilyComponentController,
    templateUrl: 'compatibilityguide/ng-templates/feature/search/solutionfamily',
};
